<template>
  <div class="Service" ref="Service">
    <Head :isWhite="isWhiteLogo" :isMenu="isMenu" @isMenuShow="isMenuShow" />
    <Banner BannerName="Service_banner" MenuName="留学服务" :MenuActive="1" />
    <div class="container">
      <p>留学服务</p>
      <span>
        集团从多维度量化整合国际院校教学标准，研发留学申研、科研背景提升、留学移民等教育产品，为广大有留学意愿的学员开辟一条安全、<br />可靠的留学渠道。以深度专业咨询模式和丰富服务体系，帮助客户制定专业留学规划，丰富学术履历，保障留学需求。
      </span>
      <div style="margin: 72px auto 89px auto; font-size: 14px">
          <img src="http://cso-group.oss-cn-hongkong.aliyuncs.com/CISO/Business/Service/study_welcome.png" width="604px; float: left; margin-right: 30px" />
          <div class="text" style="width: 790px; float: right; margin-top: 70px; line-height: 24px;">
            <span>
              <b>西索留学</b>&nbsp;&nbsp;秉承先进教育理念，以攻克名校培养国际菁英人才为核心，精心打造留学全周期服务链。服务超10000+留学生群体
			  ，留学业务深入国内外教育体系，与各大高校建立深度合作，主要业务立足北美，背景提升\留学咨询\移民签证\就业求职等一站式
			  专业服务覆盖全球。 <br/> <br/>
			  全球范围内的留学/求职的竞争变得越来越激烈，我们需要重新审视院校录取标准，职场录取要求。 招生官和面试官们更看重的是
			  在申请中展现出全面实力的学生/面试者，他们期待在学生/面试者身上看到活跃的创新思维，严谨的学术态度，实际的行动能力，
			  及时实打实的领导能力。名校名企对学生的考察不只局限于文化课分数、专业考试分数这两方面。学生的工作实习经历、论文研究
			  、交换经历、学术竞赛、社会经历等能否支撑学生的未来职业规划已经成为更重要的考核标准之一。 面对这种劣势局面，CSO国际
			  教育中心以学生为核心，从多个维度研发背景提升项目，全方位为学员提升竞争力，拉开和其他竞争者的差距，将学生打造成为高
			  层次国际化复合型人才。<br/> <br/>
            </span>
			<img src="http://cso-group.oss-cn-hongkong.aliyuncs.com/CISO/Business/Service/study_but.png" style="width: 766px;" />
          </div>
      </div>
	  <div>
          <img src="http://cso-group.oss-cn-hongkong.aliyuncs.com/CISO/Business/Service/six_study.png" style=" width: 1400px;" />
      </div>
      <ul>
        <li v-for="(item, index) in Service" :key="index" :class="isHover == index ? 'isHover' : ''" @mouseover="isHover = index">
          <div class="left">
            <p>{{ item.title }}</p>
          </div>
          <div class="right">
            <p>{{ item.title2 }}</p>
            <span>{{ item.text }}</span>
          </div>
        </li>
      </ul>
	  <span style="font-size: 22px; font-weight: bold;margin-bottom: 30px;">服务流程<p style="display:inline-block;width: 1300px;height: 1px;background-color:#000000;margin-bottom: 8px;margin-left: 10px;"></p></span>
	  <!--<input type="text" style="border-bottom:solid 1px #ccc;">-->
	  <img src="http://cso-group.oss-cn-hongkong.aliyuncs.com/CISO/Business/Service/step.png"  style="width: 1400px;" />
    </div>
    <Foot @isBackTop="isBackTop" />
  </div>
</template>
<script>
import Head from '@/components/Head'
import Banner from '@/components/Banner'
import Foot from '@/components/Foot'
export default {
  components: {
    Head,
    Banner,
    Foot
  },
  data() {
    return {
      isWhiteLogo: false,
      isMenu: false,
      isHover: 0,
      Service: [
        {
          title: '深度咨询',
          title2: '全方位深度咨询模块：教育体制 · 思维模式 · 社交 · 生活 · 未来发展规划',
          text: '西索留学深耕留学领域多年，专注从学生面临切身实际问题出发，用心解决每一位学生面临的海外学业困境和生活难题，避免留学咨询模式化。整个服务过程会从主要的海内外环境差异、思维模式切换、留学生交友圈全方位提升留学咨询服务的深度和质量。'
        },
        {
          title: '丰富模式',
          title2: '搭建留学资讯分享平台：线上社交平台·官方微信加拿大留学生圈·线上留学讲座',
          text: '官方专业留学顾问收集专业信息与院校资料，由亲历海外留学的留学生现身说法分享留学感悟与理念，以互联网线上形式与跟进讯息，打破单一模式与信息茧房，帮助学生多渠道了解最新留学资讯，指定专业详实的留学规划。'
        },
        {
          title: '流程简化',
          title2: '',
          text: '相比于繁琐的程序设计，西索更重视每一位学生的申请服务体验和申请模式的效率，故而凡是选择在西索进行留学申请服务的学生，均会提供相关的附带服务，如协助签证移民，帮助学员对接签证中心，提供最新办理签证与移民政策等。'
        }
      ]
    }
  },
  mounted() {},
  methods: {
    isMenuShow(e) {
      this.isMenu = e
    },
    isBackTop() {
      let _this = this
      let ScrollTime = setInterval(() => {
        if (_this.$refs.Service.scrollTop > 0) {
          _this.$refs.Service.scrollTop = _this.$refs.Service.scrollTop - 50
        }
        if (_this.$refs.Service.scrollTop == 0) {
          clearInterval(ScrollTime)
        }
      }, this.$refs.Service.scrollTop / 1000000)
    }
  }
}
</script>
<style lang="less" scoped>
.Service {
  width: 100%;
  height: 100%;
  min-width: 1440px;
  overflow-x: hidden;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  /deep/.Banner {
    .Menu {
      display: flex;
      align-items: center;
      justify-content: center;
      ul {
        width: 1400px;
        justify-content: space-between;
        li {
          margin-left: 0;
        }
      }
    }
  }
  .container {
    width: 1400px;
    overflow: hidden;
    margin: 72px auto 89px auto;
    > p {
      font-size: 32px;
      line-height: 1;
      text-align: center;
      font-family: 'Heavy';
      color: #111111;
    }
    > span {
      font-size: 14px;
      color: #111111;
      display: block;
      margin-top: 33px;
      text-align: center;
      line-height: 30px;
    }
    ul {
      width: 100%;
      overflow: hidden;
      display: flex;
      align-items: center;
      margin-top: 50px;
      li {
        width: 150px;
        height: 500px;
        overflow: hidden;
        transition: width 1s;
        position: relative;
        &:nth-child(1) {
          background: url('http://cso-group.oss-cn-hongkong.aliyuncs.com/CISO/Business/Service/Service_img1.png') left top no-repeat;
        }
        &:nth-child(2) {
          background: url('http://cso-group.oss-cn-hongkong.aliyuncs.com/CISO/Business/Service/Service_img2.png') left top no-repeat;
        }
        &:nth-child(3) {
          background: url('http://cso-group.oss-cn-hongkong.aliyuncs.com/CISO/Business/Service/Service_img3.png') left top no-repeat;
        }
        .left {
          width: 150px;
          height: 500px;
          overflow: hidden;
          text-align: center;
          font-size: 24px;
          color: #ffffff;
          font-family: 'Heavy';
          padding: 0 63px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .right {
          width: 950px;
          height: 500px;
          overflow: hidden;
          opacity: 0;
          transition: opacity 2s;
          position: absolute;
          left: 150px;
          top: 0;
          p {
            height: 20px;
            font-size: 20px;
            color: #ffffff;
            margin-top: 48px;
            line-height: 1;
          }
          span {
            display: block;
            width: 643px;
            height: 218px;
            background: rgba(45, 100, 250, 0.9);
            padding: 50px 75px 0 75px;
            font-size: 14px;
            line-height: 30px;
            text-align: justify;
            color: #ffffff;
            position: absolute;
            right: 0;
            bottom: 0;
          }
        }
        &.isHover {
          width: 1100px;
          .right {
            opacity: 1;
          }
        }
      }
    }
  }
}
</style>
